import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vue from 'vue'
// register globally
Vue.component('multiselect', Multiselect)
